function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1_Done",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-89.000000, -918.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "done",
  transform: "translate(89.000000, 918.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#006AB2",
  cx: 43,
  cy: 43,
  r: 43
}), /*#__PURE__*/React.createElement("g", {
  id: "thumbs",
  transform: "translate(21.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-path",
  points: "0 0 45 0 45 45 0 45"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5,45 L33.75,45 C35.6175,45 37.215,43.875 37.89,42.255 L44.685,26.3925 C44.8875,25.875 45,25.335 45,24.75 L45,20.25 C45,17.775 42.975,15.75 40.5,15.75 L26.3025,15.75 L28.44,5.4675 L28.5075,4.7475 C28.5075,3.825 28.125,2.97 27.5175,2.3625 L25.1325,0 L10.305,14.8275 C9.495,15.6375 9,16.7625 9,18 L9,40.5 C9,42.975 11.025,45 13.5,45 Z M13.5,18 L23.265,8.235 L20.25,20.25 L40.5,20.25 L40.5,24.75 L33.75,40.5 L13.5,40.5 L13.5,18 Z M0,15.75 L4.5,15.75 L4.5,42.75 L0,42.75 L0,15.75 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})))));

var SvgDone = function SvgDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "86px",
    viewBox: "0 0 86 86",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done.6f95b687.svg";
export { ForwardRef as ReactComponent };